// removed by extract-text-webpack-plugin
module.exports = {"DefaultErrorImg":"src-components-shared-CompanyLogo----CompanyLogo-module---DefaultErrorImg---2V3q0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/CompanyLogo/CompanyLogo.module.css
// module id = 377
// module chunks = 28901507966785 35783957827783